/* Zailarah - main product section: <zl-product-info> (variant logic, price, urgency, size hint, size finder, length guide,
   complete the look, quick add, add to bag, sticky bar, toast) and the gallery (counter, dots, zoom view, variant media).
   Port of zailarah-product-page-preview_13.html lines 742-989 (main script), 1948-1979 (mobile gallery) and
   2018-2072 (PDP extras). Plain ES2019, no dependencies. Uses window.ZL (global core) and ZL.cart (cart drawer).
   The markup is rendered by sections/main-product.liquid; every text comes from section / block settings through the
   data islands ([data-product-json], [data-inventory-json], [data-settings-json]). */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('zl-product-info')) return;

  var win = window;
  var doc = document;
  var ZL = (win.ZL = win.ZL || {});

  /* ------------------------------------------------------------------ helpers */

  function qs(sel, el) { return (el || doc).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function str(v) { return v == null ? '' : String(v); }
  function fill(tpl, map) {
    return str(tpl).replace(/\[(\w+)\]/g, function (m, key) { return Object.prototype.hasOwnProperty.call(map, key) ? str(map[key]) : m; });
  }
  function money(cents) { return ZL.money ? ZL.money(cents) : (cents / 100).toFixed(2); }
  function reducedMotion() { return ZL.prefersReducedMotion ? ZL.prefersReducedMotion() : false; }
  function cmToFtIn(cm) {
    var inches = Math.round(cm / 2.54);
    return Math.floor(inches / 12) + "'" + (inches % 12) + '"';
  }
  function create(tag, attrs, text) {
    var node = doc.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    if (text != null) node.textContent = text;
    return node;
  }
  function parseNums(text) { return (str(text).match(/\d+(\.\d+)?/g) || []).map(Number); }

  /* ------------------------------------------------------------------ controller (one per <zl-product-info>) */

  function init(host) {
    var root = qs('.zlp', host);
    var P = readJSON(qs('[data-product-json]', root));
    var S = readJSON(qs('[data-settings-json]', root));
    var INV = readJSON(qs('[data-inventory-json]', root)) || {};
    if (!root || !P || !S || !P.variants || !P.variants.length) return null;

    var T = S.strings || {};
    var cleanups = [];
    var timers = [];

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }
    function later(fn, ms) { var id = setTimeout(fn, ms); timers.push(id); return id; }

    /* ---------------------------------------------------------------- state */

    var form = qs('[data-product-form]', root);
    var variantInput = qs('[data-variant-input]', root);
    var atc = qs('[data-atc]', root);
    var optEls = qsa('[data-option-index]', root);
    var sizeIdx = typeof S.sizeIdx === 'number' ? S.sizeIdx : -1;
    var sticky = qs('[data-sticky]', root);
    var stickyAtc = qs('[data-sticky-atc]', root);
    var toastEl = qs('[data-toast]', root);
    var toastText = qs('[data-toast-text]', root);
    var toastTimer = null;
    var valid = true;

    function variantById(id) {
      var key = String(id);
      for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === key) return P.variants[i];
      return null;
    }
    var current = variantById(variantInput ? variantInput.value : S.variantId) || variantById(S.variantId) || P.variants[0];

    /* ---------------------------------------------------------------- size / height data (F43, F49) */

    var heightRows = (S.heights || []).map(function (r) { return { key: String(r[0]), a: Number(r[1]), b: Number(r[2]) }; })
      .filter(function (r) { return isFinite(r.a) && isFinite(r.b); });
    var weightRows = (S.weights || []).map(function (r) {
      var m = String(r[1]).match(/(\d+(?:\.\d+)?)\s*[-\u2013]\s*(\d+(?:\.\d+)?)/);
      return m ? { key: String(r[0]), a: Number(m[1]), b: Number(m[2]) } : null;
    }).filter(Boolean);
    function heightFor(size) {
      for (var i = 0; i < heightRows.length; i++) if (heightRows[i].key === String(size)) return heightRows[i];
      return null;
    }
    function sizesInProduct() {
      var out = [];
      if (sizeIdx < 0) return out;
      P.variants.forEach(function (v) { var s = v.options[sizeIdx]; if (out.indexOf(s) < 0) out.push(s); });
      return out;
    }

    /* ---------------------------------------------------------------- toast (F15) */

    function toast(msg) {
      if (!toastEl) return;
      if (toastText) toastText.textContent = msg;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = later(function () { toastEl.classList.remove('is-on'); }, S.toastDuration || 4000);
    }

    /* ---------------------------------------------------------------- add to bag (F12-F14, F16) */

    function setBusy(btn, on) {
      if (!btn) return;
      if (on) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); } else btn.removeAttribute('aria-busy');
    }
    function addItems(items, btn) {
      var cart = ZL.cart;
      if (!cart || typeof cart.add !== 'function') { toast(T.toastError); return Promise.resolve(null); }
      var mode = S.afterAdd || 'drawer';
      setBusy(btn, true);
      return cart.add(items, { open: mode === 'drawer' }).then(function (res) {
        setBusy(btn, false);
        if (btn && btn !== atc && btn !== stickyAtc) btn.disabled = false;
        syncButtons();
        if (!res || !res.ok) { toast((res && res.error) || T.toastError); return res; }
        if (mode === 'cart') { win.location.href = S.cartUrl; return res; }
        if (mode === 'toast') toast(items.length > 1 ? fill(T.toastMany, { count: items.length }) : T.toastOne);
        return res;
      });
    }

    function atcLabel() {
      if (!valid) return str(T.unavailable);
      if (!current.available) return str(T.soldOut);
      var inv = INV[current.id];
      if (inv && inv.o && T.preorder) return T.preorder;
      return str(T.add);
    }
    function shownPrice(v) {
      return S.sale && S.sale.active ? Math.round(v.price * (100 - S.sale.pct) / 100) : v.price;
    }
    function purchasable() { return valid && current && current.available; }
    function syncButtons() {
      var label = atcLabel();
      if (atc) {
        if (!atc.hasAttribute('aria-busy')) atc.disabled = !purchasable();
        var l = qs('[data-atc-label]', atc);
        if (l) l.textContent = label;
      }
      if (stickyAtc) {
        if (!stickyAtc.hasAttribute('aria-busy')) stickyAtc.disabled = !purchasable();
        stickyAtc.textContent = purchasable() ? (T.stickyAdd || label) : label;
      }
    }

    function onSubmit(e) {
      if (!ZL.cart || typeof ZL.cart.add !== 'function') return; /* native POST to /cart/add */
      e.preventDefault();
      if (!purchasable() || (atc && atc.hasAttribute('aria-busy'))) return;
      var item = { id: current.id, quantity: getQty() };
      try {
        var data = new FormData(form);
        var props = {};
        var any = false;
        data.forEach(function (value, key) {
          var m = /^properties\[(.+)\]$/.exec(key);
          if (m && typeof value === 'string' && value !== '') { props[m[1]] = value; any = true; }
          if (key === 'selling_plan' && value) item.selling_plan = value;
        });
        if (any) item.properties = props;
      } catch (err) { /* FormData unsupported: plain item */ }
      addItems([item], atc);
    }

    /* ---------------------------------------------------------------- quantity (optional block) */

    function qtyInput() { return qs('[data-qty-input]', root); }
    function getQty() {
      var input = qtyInput();
      var q = input ? parseInt(input.value, 10) : 1;
      return q > 0 ? q : 1;
    }
    function clampQty(input) {
      var step = parseInt(input.step, 10) || 1;
      var min = input.min !== '' ? parseInt(input.min, 10) : 1;
      var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      var v = parseInt(input.value, 10);
      if (!(v > 0)) v = min;
      v = Math.max(min, Math.min(max, v));
      input.value = v;
    }
    function stepQty(btn) {
      var input = qtyInput();
      if (!input) return;
      var step = parseInt(input.step, 10) || 1;
      input.value = (parseInt(input.value, 10) || 0) + (Number(btn.getAttribute('data-qty-step')) || 0) * step;
      clampQty(input);
    }

    /* ---------------------------------------------------------------- option groups (F18-F20, F25, F26) */

    function groupSelect(el) { return qs('select[data-option-select]', el); }
    function groupItems(el) { return qsa('[role=radio]', el); }
    function groupValue(el) {
      var sel = groupSelect(el);
      if (sel) return sel.value;
      var checked = qs('[role=radio][aria-checked=true]', el);
      return checked ? checked.getAttribute('data-value') : null;
    }
    function setGroupValue(el, value) {
      var sel = groupSelect(el);
      if (sel) { sel.value = value; return; }
      groupItems(el).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-value') === value ? 'true' : 'false'); });
    }
    function selected() { return optEls.map(groupValue); }
    function findVariant(vals) {
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i];
        var ok = true;
        for (var k = 0; k < optEls.length; k++) {
          var idx = Number(optEls[k].getAttribute('data-option-index'));
          if (vals[k] != null && v.options[idx] !== vals[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function selectOption(idx, value) {
      var group = optEls.filter(function (el) { return Number(el.getAttribute('data-option-index')) === idx; })[0];
      if (!group) return;
      setGroupValue(group, value);
      render(findVariant(selected()), true);
    }

    /* ---------------------------------------------------------------- render (F21, F22, F28, F29, F30) */

    /* The first render only syncs state: every price text was already printed by Liquid (`money` filter, presentment
       currency), so it is not overwritten with ZL.money (shop money format) until the visitor changes something. */
    function updatePrice(v, seed) {
      if (seed) return;
      var pr = qs('.zlp-price[data-price]', root);
      var shown = shownPrice(v);
      var priceBtn = qs('[data-atc-price]', root);
      if (priceBtn) priceBtn.textContent = (T.priceSeparator ? T.priceSeparator + ' ' : '') + money(shown);
      if (pr) {
        var now = qs('.zlp-price__now', pr);
        var was = qs('.zlp-price__was', pr);
        var mode = pr.getAttribute('data-mode');
        if (mode === 'sale') {
          if (now) now.textContent = money(shownPrice(v));
          if (was) was.textContent = money(v.price);
        } else if (mode === 'compare') {
          if (now) now.textContent = money(v.price);
          if (was) was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        } else if (now) now.textContent = money(v.price);
        var unit = qs('[data-unit-price]', pr);
        if (unit) {
          if (v.unit_price != null && v.unit) {
            unit.textContent = money(v.unit_price) + str(T.unitPriceSep) + (v.unit_ref ? v.unit_ref : '') + v.unit;
            unit.hidden = false;
          } else { unit.textContent = ''; unit.hidden = true; }
        }
      }
      var sp = qs('[data-sticky-price]', root);
      if (sp) sp.textContent = money(shown);
    }

    function updateSoldOutMarks() {
      if (!S.markSoldout && !S.disableSoldout) return;
      var vals = selected();
      optEls.forEach(function (el, k) {
        var sel = groupSelect(el);
        var chosen = vals[k];
        function soldOut(value) {
          var test = vals.slice();
          test[k] = value;
          var tv = findVariant(test);
          return !tv || !tv.available;
        }
        if (sel) {
          qsa('option', sel).forEach(function (o) {
            var base = o.getAttribute('data-label');
            if (base == null) { base = o.textContent.split(' — ')[0]; o.setAttribute('data-label', base); }
            var out = soldOut(o.value);
            o.textContent = S.markSoldout && out ? base + ' — ' + str(T.soldOut) : base;
            o.disabled = !!(S.disableSoldout && out && o.value !== chosen);
          });
          return;
        }
        groupItems(el).forEach(function (b) {
          var out = soldOut(b.getAttribute('data-value'));
          if (S.markSoldout) b.classList.toggle('is-soldout', out);
          if (S.disableSoldout) b.disabled = out && b.getAttribute('data-value') !== chosen;
        });
      });
    }

    function updateHint(v) {
      var hint = qs('[data-height-hint]', root);
      if (!hint) return;
      var text = '';
      if (sizeIdx > -1 && T.hint) {
        var h = heightFor(v.options[sizeIdx]);
        if (h) text = fill(T.hint, { size: v.options[sizeIdx], min: h.a, max: h.b, min_ft: cmToFtIn(h.a), max_ft: cmToFtIn(h.b) });
      }
      hint.textContent = text;
    }

    function otherOptionsMatch(x) {
      var vals = selected();
      for (var k = 0; k < optEls.length; k++) {
        var idx = Number(optEls[k].getAttribute('data-option-index'));
        if (idx === sizeIdx) continue;
        if (vals[k] != null && x.options[idx] !== vals[k]) return false;
      }
      return true;
    }
    /* stock status line (optional "inventory_text" block) */
    function updateInventoryText(v) {
      var el = qs('[data-inventory-text]', root);
      if (!el) return;
      var inv = INV[v.id];
      var text = str(el.getAttribute('data-in'));
      if (!v.available) text = str(el.getAttribute('data-out'));
      else if (inv && inv.o && el.getAttribute('data-pre')) text = str(el.getAttribute('data-pre'));
      else if (inv && inv.m && inv.q > 0 && inv.q <= (S.lowStock || 3) && el.getAttribute('data-low')) text = fill(el.getAttribute('data-low'), { count: inv.q });
      el.textContent = text;
      el.hidden = !text;
    }

    /* gift card recipient form (buy buttons block, gift card products only): the fields only take part in the form while
       the checkbox is ticked, as Shopify expects the properties[...] of a gift card sent to a recipient */
    function onGiftToggle(box) {
      var wrap = box.closest('[data-gift]');
      if (!wrap) return;
      var fields = qs('[data-gift-fields]', wrap);
      if (fields) fields.hidden = !box.checked;
      qsa('[data-gift-input]', wrap).forEach(function (input) { input.disabled = !box.checked; });
      var offset = qs('[data-gift-offset]', wrap);
      if (offset) offset.value = String(new Date().getTimezoneOffset());
      if (box.checked) { var first = qs('input[type=email]', wrap); if (first) first.focus(); }
    }

    /* share (optional block): the native share sheet when the browser has one, else copy the current address */
    function share(btn) {
      var url = win.location.href.split('#')[0] || btn.getAttribute('data-share-url');
      var status = qs('[data-share-status]', btn.parentNode);
      function say(msg) {
        if (!status) return;
        status.textContent = msg;
        later(function () { status.textContent = ''; }, 3500);
      }
      if (win.navigator && typeof win.navigator.share === 'function') {
        win.navigator.share({ title: btn.getAttribute('data-share-title') || P.title, url: url }).catch(function () { /* dismissed */ });
        return;
      }
      function legacy() {
        var ta = create('textarea', { 'aria-hidden': 'true', readonly: '', tabindex: '-1', style: 'position:fixed;top:0;left:0;opacity:0' });
        ta.value = url;
        doc.body.appendChild(ta);
        ta.select();
        var ok = false;
        try { ok = doc.execCommand('copy'); } catch (e) { ok = false; }
        doc.body.removeChild(ta);
        say(ok ? btn.getAttribute('data-copied') : btn.getAttribute('data-failed'));
      }
      if (win.navigator && win.navigator.clipboard && typeof win.navigator.clipboard.writeText === 'function') {
        win.navigator.clipboard.writeText(url).then(function () { say(btn.getAttribute('data-copied')); }, legacy);
      } else legacy();
    }

    function updateUrgency(v) {
      var u = qs('[data-urgency]', root);
      if (!u) return;
      var msg = '';
      var inv = INV[v.id];
      if (S.lowStockEnabled && v.available && inv && inv.m && inv.q > 0 && inv.q <= S.lowStock) {
        msg = sizeIdx > -1
          ? fill(T.lowStock, { count: inv.q, size: v.options[sizeIdx] })
          : fill(T.lowStockNoSize, { count: inv.q });
      } else if (S.fewSizes && sizeIdx > -1) {
        var sizes = sizesInProduct();
        var total = sizes.length;
        var out = 0;
        sizes.forEach(function (s) {
          var any = P.variants.some(function (x) { return x.options[sizeIdx] === s && x.available && otherOptionsMatch(x); });
          if (!any) out++;
        });
        if (total >= (S.fewMin || 4) && out > 0 && out < total && out / total >= (S.fewRatio || 40) / 100) {
          msg = fill(T.fewSizes, { left: total - out, total: total });
        }
      }
      u.textContent = msg;
    }

    function updateLengthTable() {
      var size = sizeIdx > -1 && current ? current.options[sizeIdx] : null;
      qsa('.zlx-table td[data-s]', root).forEach(function (td) { td.classList.toggle('is-sel', td.getAttribute('data-s') === size); });
    }

    var seeded = false;
    function render(v, user) {
      var seed = !user && !seeded;
      seeded = true;
      valid = !!v;
      if (v) current = v;
      syncButtons();
      if (!v) return;

      if (variantInput && variantInput.value !== String(v.id)) {
        variantInput.value = v.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true })); /* dynamic checkout buttons listen to it */
      }
      optEls.forEach(function (el) {
        var idx = Number(el.getAttribute('data-option-index'));
        setGroupValue(el, v.options[idx]);
        var label = qs('[data-option-value]', el);
        if (label) label.textContent = v.options[idx];
      });
      updatePrice(v, seed);

      var stSize = qs('[data-sticky-size]', root);
      if (stSize && sizeIdx > -1) stSize.textContent = '· ' + v.options[sizeIdx];
      var sku = qs('[data-sku]', root);
      if (sku) {
        var skuVal = qs('[data-sku-value]', sku);
        if (skuVal) skuVal.textContent = v.sku || '';
        sku.hidden = !v.sku;
      }
      var notify = qs('[data-notify]', root);
      if (notify) {
        notify.hidden = !!v.available && !qs('[data-notify-posted]', notify); /* keep the confirmation visible after the form was sent */
        notify.setAttribute('data-variant', v.id); /* Klaviyo back in stock subscribes the selected variant */
        var tags = qs('[data-notify-tags]', notify);
        if (tags) tags.value = tags.getAttribute('data-base') + ',notify-variant-' + v.id;
      }
      qsa('[data-pickup-variant]', root).forEach(function (p) { p.hidden = p.getAttribute('data-pickup-variant') !== String(v.id); });

      updateSoldOutMarks();
      updateHint(v);
      updateUrgency(v);
      updateInventoryText(v);
      updateLengthTable();
      updateLook(seed);
      gallery.syncVariant(v, !!user);

      if (user) {
        if (S.updateUrl && win.history && history.replaceState) {
          try {
            var url = new URL(win.location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState({}, '', url.toString());
          } catch (err) { /* ignore */ }
        }
        ZL.emit && ZL.emit('zl:product:variant', { variant: v, product: P, section: S.sectionId });
      }
    }

    function onOptionClick(button) {
      if (button.disabled) return;
      var group = button.closest('[data-option-index]');
      if (!group) return;
      setGroupValue(group, button.getAttribute('data-value'));
      render(findVariant(selected()), true);
    }
    function onOptionKey(e) {
      var key = e.key;
      if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'ArrowDown' && key !== 'ArrowUp') return;
      var button = e.target.closest ? e.target.closest('[role=radio]') : null;
      var group = button && button.closest('[role=radiogroup]');
      if (!group || !button.closest('[data-option-index]')) return;
      var items = groupItems(group).filter(function (b) { return !b.disabled; });
      var at = items.indexOf(button);
      if (at < 0) return;
      e.preventDefault();
      var next = items[(at + (key === 'ArrowRight' || key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
      next.focus();
      onOptionClick(next);
    }

    /* ---------------------------------------------------------------- complete the look (F31-F35) */

    function selfPrice(v) { return S.lookPriceMode === 'sale' ? shownPrice(v) : v.price; }
    function lookPrefix() { return str(T.lookSizePrefix).replace(/\s+$/, '') + ' '; }
    function updateLook(seed) {
      var box = qs('[data-look]', root);
      if (!box) return;
      var total = 0;
      var count = 0;
      qsa('[data-look-item]', box).forEach(function (row) {
        if (row.hasAttribute('data-self')) {
          var sp = current ? selfPrice(current) : Number(row.getAttribute('data-price'));
          row.setAttribute('data-price', sp);
          var spEl = qs('[data-look-self-price]', row);
          if (spEl && !seed) spEl.textContent = money(sp);
          var szEl = qs('[data-look-self-size]', row);
          if (szEl && sizeIdx > -1 && current) szEl.textContent = lookPrefix() + current.options[sizeIdx];
          total += sp;
          count++;
          return;
        }
        var chk = qs('[data-look-check]', row);
        var sel = qs('[data-look-variant]', row);
        if (!sel) return;
        var price = sel.tagName === 'SELECT'
          ? Number(sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].getAttribute('data-price'))
          : Number(sel.getAttribute('data-price'));
        var lp = qs('[data-look-price]', row);
        if (lp && !seed) lp.textContent = money(price);
        if (chk && chk.checked) { total += price; count++; }
      });
      var totalEl = qs('[data-look-total]', box);
      var bPct = Number(box.getAttribute('data-bundle-pct')) || 0;
      var bOn = bPct > 0 && count >= (Number(box.getAttribute('data-bundle-min')) || 2);
      var bLine = qs('[data-look-bundle]', box);
      var wasEl = qs('[data-look-was]', box);
      var shownTotal = bOn ? Math.round(total * (100 - bPct) / 100) : total;
      if (bLine) { bLine.hidden = !bOn; var sv = qs('[data-look-save]', bLine); if (sv) sv.textContent = bOn ? '- ' + money(total - shownTotal) : ''; }
      var noteEl = qs('[data-look-note]', box); if (noteEl) noteEl.hidden = bOn;
      if (wasEl) { wasEl.hidden = !bOn; wasEl.textContent = bOn ? money(total) : ''; }
      if (totalEl && (!seed || bOn)) totalEl.textContent = money(shownTotal);
      var countEl = qs('[data-look-count]', box);
      if (countEl) countEl.textContent = count === 1 ? str(T.countOne) : fill(T.countMany, { n: count });
    }
    function lookAdd(btn) {
      var box = qs('[data-look]', root);
      if (!box) return;
      if (!purchasable()) { toast(T.toastChooseSize); return; }
      var items = [{ id: current.id, quantity: 1 }];
      qsa('[data-look-item]', box).forEach(function (row) {
        if (row.hasAttribute('data-self')) return;
        var chk = qs('[data-look-check]', row);
        var sel = qs('[data-look-variant]', row);
        if (chk && chk.checked && sel && sel.value) items.push({ id: Number(sel.value), quantity: 1 });
      });
      addItems(items, btn);
    }
    function loadComplementary() {
      var box = qs('[data-look-recs-url]', root);
      if (!box || !ZL.fetchHTML) return;
      var url = box.getAttribute('data-look-recs-url');
      ZL.fetchHTML(url).then(function (parsed) {
        if (!host.isConnected) return;
        var holder = parsed.querySelector('[data-look-recs]');
        var rows = holder ? qsa('.zlp-look__row', holder) : [];
        if (!rows.length) { box.remove(); return; }
        var foot = qs('.zlp-look__foot', box);
        rows.forEach(function (row) { box.insertBefore(doc.importNode(row, true), foot); });
        box.hidden = false;
        box.removeAttribute('data-look-recs-url');
        updateLook();
        if (ZL.emit) ZL.emit('zl:content:replaced', { root: box });
      }).catch(function () { box.remove(); });
    }

    /* ---------------------------------------------------------------- quick add (F36-F39) */

    function miniAdd(btn) {
      var card = btn.closest('[data-mini]');
      var sel = card && qs('[data-mini-variant]', card);
      if (!sel || !sel.value) return;
      addItems([{ id: Number(sel.value), quantity: 1 }], btn);
    }
    function miniPrice(select) {
      var card = select.closest('[data-mini]');
      var price = qs('[data-mini-price]', card);
      var opt = select.options[select.selectedIndex];
      if (price && opt && opt.getAttribute('data-price') != null) price.textContent = money(Number(opt.getAttribute('data-price')));
      var add = qs('[data-mini-add]', card);
      if (add && opt) add.disabled = opt.disabled;
    }

    /* ---------------------------------------------------------------- length guide toggle (F51) */

    function toggleLengths(btn) {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var wrap = btn.closest('.zlx-model');
      var table = wrap && qs('.zlx-table', wrap);
      var note = wrap && qs('[data-zlx-note]', wrap);
      if (table) table.hidden = !open;
      if (note) note.hidden = !open;
    }

    /* ---------------------------------------------------------------- size finder (F40-F49) */

    var dlg = qs('[data-finder]', root);
    var recommended = null;
    var finderLocked = false;

    function showResult(size, extra) {
      var r = qs('[data-finder-result]', dlg);
      if (!r) return;
      recommended = size;
      var avail = P.variants.some(function (v) { return v.options[sizeIdx] === size && v.available; });
      r.textContent = '';
      var parts = str(T.finderResult).split('[size]');
      r.appendChild(doc.createTextNode(parts[0]));
      r.appendChild(create('b', null, size));
      if (parts.length > 1) r.appendChild(doc.createTextNode(parts.slice(1).join('')));
      if (extra) {
        r.appendChild(create('br'));
        r.appendChild(create('span', { 'class': 'zlp-muted' }, extra));
      }
      if (!avail) {
        r.appendChild(create('br'));
        r.appendChild(doc.createTextNode(str(T.finderSoldout)));
      }
      r.classList.add('is-on');
      var apply = qs('[data-finder-apply]', dlg);
      if (apply) apply.hidden = !avail;
    }
    var LETTER_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '1X', '2X', '3X'];
    var hUnit = 'ft';
    var wUnit = 'lb';
    function numOf(sel) {
      var el = qs(sel, dlg);
      var v = el ? parseFloat(String(el.value).replace(',', '.')) : NaN;
      return isFinite(v) && v > 0 ? v : 0;
    }
    function readCm() {
      if (hUnit === 'cm') return numOf('[data-h-cm]');
      var ft = numOf('[data-h-ft]'), inch = numOf('[data-h-in]');
      return ft || inch ? (ft * 12 + inch) * 2.54 : 0;
    }
    function readKg() {
      if (wUnit === 'kg') return numOf('[data-w-kg]');
      if (wUnit === 'lb') return numOf('[data-w-lb]') * 0.45359237;
      var st = numOf('[data-w-st]'), lb = numOf('[data-w-stlb]');
      return st || lb ? (st * 14 + lb) * 0.45359237 : 0;
    }
    function rangeIndex(rows, v) {
      if (!rows.length || !v) return null;
      if (v < rows[0].a) return { i: 0, flag: 'low' };
      for (var k = 0; k < rows.length; k++) if (v < rows[k].b) return { i: k, flag: '' };
      return { i: rows.length - 1, flag: 'high' };
    }
    function sortedSizes() {
      var sizes = sizesInProduct().slice();
      var allNum = sizes.every(function (x) { return !isNaN(parseFloat(x)); });
      var rank = function (x) {
        var tok = String(x).split(/[\/\s]/)[0].toUpperCase();
        var r = LETTER_ORDER.indexOf(tok);
        return r < 0 ? 99 : r;
      };
      sizes.sort(function (p, q) { return allNum ? parseFloat(p) - parseFloat(q) : rank(p) - rank(q); });
      return sizes;
    }
    function rowCount() { return Math.max(heightRows.length, weightRows.length); }
    function pickSize(i) {
      var sizes = sortedSizes();
      if (!sizes.length) return null;
      var hk = heightRows[i] && heightRows[i].key, wk = weightRows[i] && weightRows[i].key;
      if (hk && sizes.indexOf(hk) > -1) return hk;
      if (wk && sizes.indexOf(wk) > -1) return wk;
      var n = rowCount();
      var pos = n > 1 ? Math.round(i * (sizes.length - 1) / (n - 1)) : 0;
      return sizes[Math.min(sizes.length - 1, Math.max(0, pos))];
    }
    function fmtHeight(cm) { return cmToFtIn(cm) + ' / ' + Math.round(cm) + ' ' + str(T.unitCm); }
    function fmtWeight(kg) { return (Math.round(kg * 10) / 10) + ' ' + str(T.unitKg) + ' / ' + Math.round(kg * 2.20462) + ' ' + str(T.unitLb); }
    function calc() {
      var r = qs('[data-finder-result]', dlg);
      var apply = qs('[data-finder-apply]', dlg);
      var cm = readCm(), kg = readKg();
      if (!cm && !kg) {
        recommended = null;
        if (r) { r.textContent = ''; r.classList.remove('is-on'); }
        if (apply) apply.hidden = true;
        return;
      }
      var h = cm ? rangeIndex(heightRows, cm) : null;
      var w = kg ? rangeIndex(weightRows, kg) : null;
      if (!h && !w) { if (r) { r.textContent = str(T.finderNeedOne); r.classList.add('is-on'); } return; }
      var idx = Math.max(h ? h.i : 0, w ? w.i : 0);
      var size = pickSize(idx);
      if (!size) return;
      var basis = h && w ? T.finderBoth : (h ? T.finderBasisHeight : T.finderBasisWeight);
      var extra = fill(basis, { height: cm ? fmtHeight(cm) : '', weight: kg ? fmtWeight(kg) : '' });
      if (h && w && w.i > h.i) extra += ' ' + str(T.finderWeightLarger);
      if (h && h.flag === 'low') extra += ' ' + str(T.finderShort);
      if (h && h.flag === 'high') extra += ' ' + str(T.finderTall);
      showResult(size, extra);
    }
    function buildChart() {
      var table = qs('[data-finder-chart]', dlg);
      if (!table) return;
      table.textContent = '';
      var n = rowCount();
      if (!n || !sizesInProduct().length) return;
      var merged = [];
      for (var i = 0; i < n; i++) {
        var size = pickSize(i);
        if (size == null) continue;
        var last = merged[merged.length - 1];
        var hr = heightRows[i], wr = weightRows[i];
        if (last && last.size === size) {
          if (hr) { last.ha = last.ha == null ? hr.a : Math.min(last.ha, hr.a); last.hb = last.hb == null ? hr.b : Math.max(last.hb, hr.b); }
          if (wr) { last.wa = last.wa == null ? wr.a : Math.min(last.wa, wr.a); last.wb = last.wb == null ? wr.b : Math.max(last.wb, wr.b); }
        } else {
          merged.push({ size: size, ha: hr ? hr.a : null, hb: hr ? hr.b : null, wa: wr ? wr.a : null, wb: wr ? wr.b : null });
        }
      }
      var body = create('tbody');
      function row(cells) {
        var tr = create('tr');
        cells.forEach(function (c) { tr.appendChild(create(c.th ? 'th' : 'td', c.cls ? { 'class': c.cls } : null, c.text)); });
        body.appendChild(tr);
      }
      var withH = merged.some(function (x) { return x.ha != null; });
      var withW = merged.some(function (x) { return x.wa != null; });
      var head = [{ th: 1, text: T.chartSize }];
      if (withH) head.push({ th: 1, text: T.chartHeight });
      if (withW) head.push({ th: 1, text: T.chartWeight });
      row(head);
      merged.forEach(function (x) {
        var cells = [{ text: x.size }];
        if (withH) cells.push({ text: x.ha == null ? '' : cmToFtIn(x.ha) + '\u2013' + cmToFtIn(x.hb) + '  (' + Math.round(x.ha) + '\u2013' + Math.round(x.hb) + ' ' + str(T.unitCm) + ')' });
        if (withW) cells.push({ text: x.wa == null ? '' : Math.round(x.wa * 2.20462) + '\u2013' + Math.round(x.wb * 2.20462) + ' ' + str(T.unitLb) + '  (' + Math.round(x.wa) + '\u2013' + Math.round(x.wb) + ' ' + str(T.unitKg) + ')' });
        row(cells);
      });
      table.appendChild(body);
    }
    function initFinder() {
      if (!dlg || sizeIdx < 0 || dlg.hasAttribute('data-chart-only')) return;
      var hb = qs('[data-hunit][aria-pressed=true]', dlg);
      var wb = qs('[data-wunit][aria-pressed=true]', dlg);
      hUnit = hb ? hb.getAttribute('data-hunit') : 'ft';
      wUnit = wb ? wb.getAttribute('data-wunit') : 'lb';
      buildChart();
    }
    function openFinder(mode) {
      if (!dlg || dlg.open) return;
      if (mode === 'chart' || mode === 'calc') dlg.setAttribute('data-mode', mode);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      if (ZL.lockScroll && !finderLocked) { ZL.lockScroll('zlp-finder'); finderLocked = true; }
    }
    function closeFinder() {
      if (!dlg) return;
      if (typeof dlg.close === 'function') { if (dlg.open) dlg.close(); } else dlg.removeAttribute('open');
      onFinderClosed();
    }
    function onFinderClosed() {
      if (ZL.unlockScroll && finderLocked) { ZL.unlockScroll('zlp-finder'); finderLocked = false; }
    }
    function applyFinder() {
      if (recommended != null) selectOption(sizeIdx, recommended);
      closeFinder();
    }
    function onUnit(btn) {
      var isH = btn.hasAttribute('data-hunit');
      var unit = btn.getAttribute(isH ? 'data-hunit' : 'data-wunit');
      qsa(isH ? '[data-hunit]' : '[data-wunit]', dlg).forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
      if (isH) {
        hUnit = unit;
        var c = qs('[data-h-cm-row]', dlg), ft = qs('[data-h-ft-row]', dlg);
        if (c) c.hidden = unit !== 'cm';
        if (ft) ft.hidden = unit !== 'ft';
      } else {
        wUnit = unit;
        ['kg', 'lb', 'st'].forEach(function (k) { var rw = qs('[data-w-' + k + '-row]', dlg); if (rw) rw.hidden = unit !== k; });
      }
      calc();
    }
    function onFinderInput() { calc(); }

    /* ---------------------------------------------------------------- sticky add to bag, mobile (F54-F56) */

    var stickyState = { past: false, footer: false };
    var footerObserver = null;
    function updateSticky() {
      if (!sticky) return;
      var show = stickyState.past && !stickyState.footer;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function initSticky() {
      var buy = qs('.zlp-buy', root);
      if (!sticky || !buy || !('IntersectionObserver' in win)) return;
      var check = function () { stickyState.past = buy.getBoundingClientRect().bottom < 0; updateSticky(); };
      on(win, 'scroll', check, { passive: true });
      check();
      /* every footer-group section (trust bar, footer ...): the bar hides as soon as any of them is on screen */
      var feet = qsa('.shopify-section-group-footer-group');
      if (!feet.length) { var one = doc.querySelector('footer.zl-footer, footer'); if (one) feet = [one]; }
      if (feet.length) {
        var visible = new Set();
        footerObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
          stickyState.footer = visible.size > 0;
          updateSticky();
        });
        feet.forEach(function (el) { footerObserver.observe(el); });
      }
    }

    /* ---------------------------------------------------------------- gallery (F4-F11d) */

    var gallery = (function () {
      var track = qs('[data-gallery]', root);
      var counter = qs('[data-gallery-count]', root);
      var bar = qs('[data-gallery-bar]', root);
      var dotsWrap = qs('.zlp-gdots', root);
      var zoomBtn = qs('[data-zoom]', root);
      var lb = qs('.zlp-lb', host);
      var allItems = track ? qsa('.zlp-gallery__item', track) : [];
      var index = 0;
      var lbOpen = false;
      var model = { loaded: false };

      function items() { return track ? qsa('.zlp-gallery__item', track) : []; }
      function dots() { return dotsWrap ? qsa('button', dotsWrap) : []; }

      function pauseItem(item) {
        if (!item) return;
        qsa('video', item).forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
        qsa('iframe', item).forEach(function (f) {
          try {
            var src = f.getAttribute('src') || '';
            if (/youtube/.test(src)) f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
            else if (/vimeo/.test(src)) f.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          } catch (e) { /* ignore */ }
        });
      }

      function update() {
        if (!track) return;
        var list = items();
        var n = list.length || 1;
        var i = Math.min(Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1)), n - 1);
        if (i < 0) i = 0;
        if (counter) counter.textContent = (i + 1) + ' / ' + n;
        if (bar) { var w = 100 / n; bar.style.width = w + '%'; bar.style.left = (i * w) + '%'; }
        dots().forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (i !== index) { pauseItem(list[index]); index = i; }
      }

      function scrollToItem(item) {
        if (!track || !item) return;
        var behavior = reducedMotion() ? 'auto' : 'smooth';
        if (track.scrollWidth > track.clientWidth + 1) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: behavior });
        else if (item.scrollIntoView) item.scrollIntoView({ block: 'nearest', behavior: behavior });
      }

      function buildDots() {
        if (!dotsWrap) return;
        var n = items().length;
        dotsWrap.textContent = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          dotsWrap.appendChild(create('button', {
            type: 'button',
            'aria-label': fill(T.dotLabel, { n: i + 1, total: n }),
            'aria-current': i === 0 ? 'true' : 'false'
          }));
        }
      }

      function applyFilter(v) {
        if (!S.hideVariantMedia || !track || !allItems.length) return;
        var owners = {};
        P.variants.forEach(function (x) {
          if (x.featured_media_id != null) { var k = String(x.featured_media_id); (owners[k] = owners[k] || []).push(String(x.id)); }
        });
        var keep = allItems.filter(function (it) {
          var o = owners[it.getAttribute('data-media-id')];
          return !o || o.indexOf(String(v.id)) > -1;
        });
        if (!keep.length) keep = allItems.slice();
        var now = items();
        var same = now.length === keep.length && now.every(function (it, k) { return it === keep[k]; });
        if (same) return;
        allItems.forEach(function (it) { if (keep.indexOf(it) < 0 && it.parentNode === track) track.removeChild(it); });
        keep.forEach(function (it) { track.appendChild(it); });
        track.scrollLeft = 0;
        index = 0;
        buildDots();
        update();
      }

      function syncVariant(v, user) {
        applyFilter(v);
        if (user && S.scrollToVariantMedia && v.featured_media_id != null && track) {
          scrollToItem(qs('[data-media-id="' + v.featured_media_id + '"]', track));
        }
      }

      /* zoom view (F9, F10) */
      function ensureLightboxImages() {
        if (!lb || qs('img', lb)) return;
        var tpl = qs('template[data-lightbox-images]', lb);
        if (!tpl || !tpl.content) return;
        var frag = tpl.content.cloneNode(true);
        qsa('img', frag).forEach(function (im) { im.setAttribute('loading', 'eager'); });
        lb.appendChild(frag);
      }
      function openZoom() {
        if (!lb) return;
        ensureLightboxImages();
        lb.classList.add('is-on');
        lbOpen = true;
        if (ZL.lockScroll) ZL.lockScroll('zlp-lb');
        var cur = items()[index];
        var id = cur && cur.getAttribute('data-media-id');
        var target = id ? qs('img[data-media-id="' + id + '"]', lb) : qsa('img', lb)[index];
        lb.scrollTop = target ? target.offsetTop : 0;
        var close = qs('.zlp-lb__close', lb);
        if (ZL.trapFocus) ZL.trapFocus(lb, { initialFocus: close || undefined, returnFocus: zoomBtn || undefined, onEscape: closeZoom });
        else if (close) close.focus();
        /* .zlp-lb is visibility:hidden until its opacity/visibility transition starts, so the focus() above can fail in
           the same tick: move focus to the close button once the overlay is actually focusable (the trap is already set,
           so Escape / Tab are handled meanwhile). */
        if (close) {
          var focusClose = function () {
            if (lbOpen && !lb.contains(doc.activeElement)) { try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); } }
          };
          focusClose();
          if (win.requestAnimationFrame) win.requestAnimationFrame(function () { focusClose(); win.requestAnimationFrame(focusClose); });
          later(focusClose, 80);
        }
      }
      function closeZoom() {
        if (!lb || !lbOpen) return;
        lb.classList.remove('is-on');
        lbOpen = false;
        if (ZL.unlockScroll) ZL.unlockScroll('zlp-lb');
        if (ZL.releaseFocus) ZL.releaseFocus(lb);
        else if (zoomBtn) zoomBtn.focus({ preventScroll: true });
      }

      /* 3D models: Shopify's viewer UI is loaded the first time the product has a model */
      function initModels() {
        var models = track ? qsa('model-viewer', track) : [];
        if (!models.length || model.loaded) return;
        model.loaded = true;
        if (!qs('link[data-zl-model-css]', doc.head)) {
          var link = create('link', { rel: 'stylesheet', href: 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css', 'data-zl-model-css': '' });
          doc.head.appendChild(link);
        }
        if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
          win.Shopify.loadFeatures([{
            name: 'model-viewer-ui', version: '1.0',
            onLoad: function (err) {
              if (err || !win.Shopify.ModelViewerUI) return;
              models.forEach(function (m) { try { new win.Shopify.ModelViewerUI(m); } catch (e) { /* ignore */ } });
            }
          }]);
        }
      }

      if (track) {
        on(track, 'scroll', update, { passive: true });
        update();
        initModels();
      }
      if (dotsWrap) on(dotsWrap, 'click', function (e) {
        var b = e.target.closest ? e.target.closest('button') : null;
        if (!b) return;
        var at = dots().indexOf(b);
        if (at > -1) scrollToItem(items()[at]);
      });

      return {
        syncVariant: syncVariant,
        openZoom: openZoom,
        closeZoom: closeZoom,
        isZoomOpen: function () { return lbOpen; },
        destroy: function () { if (lbOpen) closeZoom(); }
      };
    })();

    /* ---------------------------------------------------------------- one delegated set of listeners */

    function onClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el;
      if (dlg && t === dlg) { closeFinder(); return; }
      if ((el = t.closest('[role=radio]')) && el.closest('[data-option-index]') && root.contains(el)) { onOptionClick(el); return; }
      if ((el = t.closest('[data-open-finder]'))) { openFinder(el.getAttribute('data-open-finder')); return; }
      if (t.closest('[data-close-finder]')) { closeFinder(); return; }
      if (t.closest('[data-finder-apply]')) { applyFinder(); return; }
      if ((el = t.closest('[data-hunit], [data-wunit]')) && dlg && dlg.contains(el)) { onUnit(el); return; }
      if ((el = t.closest('.zlx-toggle'))) { toggleLengths(el); return; }
      if ((el = t.closest('[data-look-add]'))) { lookAdd(el); return; }
      if ((el = t.closest('[data-mini-add]'))) { miniAdd(el); return; }
      if (t.closest('[data-sticky-atc]')) {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        return;
      }
      if ((el = t.closest('[data-qty-step]'))) { stepQty(el); return; }
      if ((el = t.closest('[data-share]'))) { share(el); return; }
      if (t.closest('[data-zoom]')) { gallery.openZoom(); return; }
      if (t.closest('.zlp-lb__close')) { gallery.closeZoom(); return; }
    }
    function onChange(e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('select[data-option-select]')) { render(findVariant(selected()), true); return; }
      if (t.matches('[data-look-check], select[data-look-variant]')) { updateLook(); return; }
      if (t.matches('select[data-mini-variant]')) { miniPrice(t); return; }
      if (t.matches('[data-gift-toggle]')) { onGiftToggle(t); return; }
      if (t.matches('[data-qty-input]')) clampQty(t);
    }
    function onInput(e) {
      var t = e.target;
      if (t && t.matches && dlg && dlg.contains(t) && t.matches('[data-h-cm], [data-h-ft], [data-h-in], [data-w-kg], [data-w-lb], [data-w-st], [data-w-stlb]')) onFinderInput(t);
    }

    on(host, 'click', onClick);
    on(host, 'change', onChange);
    on(host, 'input', onInput);
    on(host, 'keydown', onOptionKey);
    if (form) on(form, 'submit', onSubmit);
    if (dlg) on(dlg, 'close', onFinderClosed);

    /* theme editor: bring the selected block into view and open a selected collapsible row (F67) */
    if (ZL.onSection) {
      cleanups.push(ZL.onSection(host, {
        blockSelect: function (e) {
          var node = e.target;
          if (!node || !node.nodeType || !host.contains(node)) return;
          if (node.tagName === 'DETAILS') node.open = true;
          if (node.scrollIntoView) node.scrollIntoView({ block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
        }
      }));
    }

    /* ---------------------------------------------------------------- start */

    initFinder();
    initSticky();
    loadComplementary();
    render(current, false);

    return { destroy: function () {
      gallery.destroy();
      clearTimeout(toastTimer);
      timers.forEach(clearTimeout);
      if (footerObserver) footerObserver.disconnect();
      if (finderLocked && ZL.unlockScroll) { ZL.unlockScroll('zlp-finder'); finderLocked = false; }
      cleanups.forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
      cleanups = [];
    } };
  }

  /* ------------------------------------------------------------------ custom element */

  class ZlProductInfo extends HTMLElement {
    connectedCallback() {
      if (this._ctl) return;
      this._ctl = init(this);
    }
    disconnectedCallback() {
      if (this._ctl) { this._ctl.destroy(); this._ctl = null; }
    }
  }
  customElements.define('zl-product-info', ZlProductInfo);
})();

/* size chart: unit buttons */
(function () {
  "use strict";
  var KEY = "zl:chart-unit";
  function set(chart, unit) {
    chart.setAttribute("data-unit", unit);
    [].forEach.call(chart.querySelectorAll("[data-chart-unit]"), function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-chart-unit") === unit ? "true" : "false"); });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-chart-unit]") : null;
    if (!b) return;
    var chart = b.closest("[data-zlp-chart]"); if (!chart) return;
    var unit = b.getAttribute("data-chart-unit");
    set(chart, unit);
    try { localStorage.setItem(KEY, unit); } catch (err) {}
  });
  function init(root) {
    var saved = null; try { saved = localStorage.getItem(KEY); } catch (err) {}
    if (saved !== "cm" && saved !== "in") return;
    [].forEach.call((root || document).querySelectorAll("[data-zlp-chart]"), function (c) { if (c.querySelector("[data-chart-unit]")) set(c, saved); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); }); else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
